import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import GuideForm from '../Form';
import { fetchGuide, updateGuide } from '@resources/Guide/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Update = (props) => {
	const { module, fetchGuide, guide, updateGuide, visible, onCancel } = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchGuide(visible);
		};
		visible && fetchData();
	}, [fetchGuide, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateGuide(guide._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.guide.update',
							defaultMessage:
								'An existing Guide entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[guide]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.guide',
					defaultMessage: 'Update Guide',
				})}
			</Title>
			{!isEmpty(guide) && (
				<GuideForm
					data={guide}
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	guide,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		guide,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchGuide,
	updateGuide,
	fetchModulesBySubmoduleCode,
})(Update);
